import { ReportAlertsWidget } from "../../../widgets";
import { QualificationAlertsWidget } from "../../../widgets";
// import { VehicleAlertsWidget } from "../../../widgets";
import { combineReducers } from "redux";

export default combineReducers({
    [ReportAlertsWidget.reducer_key]: ReportAlertsWidget.reducer,
    [QualificationAlertsWidget.reducer_key]: QualificationAlertsWidget.reducer
    // [VehicleAlertsWidget.reducer_key]: ReportAlertsWidget.reducer
});
